






































































import { Component, Vue } from 'vue-property-decorator';
import firebase from "../firebase";
import { DbUtile } from "../database/DbUtile";
import { DbCourseManagement, DbCourseManagementDetails } from "../database/DbCourseManagement";

import Common from '../common/Common';
import ValidateStatus from './ValidateStatus.vue';

@Component({
  components: {
      ValidateStatus
  }
})
export default class ModalCourseManagement extends Vue {
    private dbUtile = new DbUtile();
    private closeCallback: (() => void) | null = null;

    private id: string | null = null;
    private src: DbCourseManagement | null = new DbCourseManagement();
    private detailsRows = "1\tC001\t01. ○○○○\tオンデマンド\t123456\t不可\t\t2020/12/07 00:00:00\t2020/12/16 23:59:59\t50\txxxxxxxxxxx\r\n1\tC001\t01. ○○○○\tオンデマンド\t123456\t不可\t\t2020/12/07 00:00:00\t2020/12/16 23:59:59\t50\txxxxxxxxxxx\r\n";
    // private detailsRows = "";

    // 入力チェック
    validateStatus = {
        error: false,
        message: ""
    }

    showModal(callback: () => void, id: string | null = null, src: DbCourseManagement | null = null) {
        this.closeCallback = callback;
        this.id = id;
        this.src = (src == null)? new DbCourseManagement(): src;
        console.log("src", this.src);
        this.validateStatus = {
            error: false,
            message: ""
        };
        const modal = document.getElementById("modal-course-management");
        if (modal) {
            modal.classList.toggle('is-active');
        }
    }

    closeModal() {
        const modal = document.getElementById("modal-course-management");
        if (modal) {
            modal.classList.toggle('is-active');
        }
    }

    // 詳細登録
    addDbCourseManagementDetails(id: string, data: string): Promise<void> {
        return new Promise((resolve,reject) => {
            if (data.length == 0){   
                resolve();             
                return;
            }
            data.split("\r\n").forEach((rows) => {
                console.log("rows", rows);
                const columns = rows.split("\t");
                console.log("columns", columns);        
                // DbCourseManagementDetails 新規登録
                const src = new DbCourseManagementDetails();
                src.subcommitteeNumber = columns[0];
                src.chapterID = columns[1];
                src.lectureName = columns[2];
                src.classification = columns[3];
                src.videoID = columns[4];
                src.playbackSpeedChange = columns[5];
                src.meetingURL = columns[6];
                src.from = columns[7];
                src.to = columns[8];
                src.time = columns[9]; 
                src.description = columns[10]; 
                this.dbUtile.addCourseManagementDetails(id, src)
                    .then((data) => {
                        console.log('data', data);
                    })
                    .catch((e) => {
                        console.log("e", e);
                    });
            });
            resolve();           
        });
    }



    // 入力チェック
    validate(): boolean {
        if (this.src == null){
            return false;
        }
        // 講習ID
        if (Common.isValidate(this.src.courseId, this.validateStatus, "講習ID は必須入力です") == false){
            return false;
        }
        // 講習名
        if (Common.isValidate(this.src.name, this.validateStatus, "講習名 は必須入力です") == false){
            return false;
        }
        // 領域
        if (Common.isValidate(this.src.region, this.validateStatus, "領域 は必須入力です") == false){
            return false;
        }
        // 講師
        if (Common.isValidate(this.src.teacher, this.validateStatus, "講師 は必須入力です") == false){
            return false;
        }      
        if (Common.isValidate(this.src.from, this.validateStatus, "期間 は必須入力です") == false){
            return false;
        }
        if (Common.isValidate(this.src.to, this.validateStatus, "期間 は必須入力です") == false){
            return false;
        }   
        if (Common.isValidate(this.src.capacity, this.validateStatus, "定員 は必須入力です") == false){
            return false;
        }
        return true;
    }

    // DB に 講習 情報を保存する
    addCourseManagement() {
        // 入力チェック
        if (this.validate() == false) {
            return
        }

        // 保存処理
        // TODO detailsRows を 行分割して DbCourseManagementDetails 登録
        this.dbUtile.addCourseManagement(this.id!, this.src! )
            .then((courseManagement: DbCourseManagement) => { 
                this.addDbCourseManagementDetails( this.id!, this.detailsRows)
                    .then(() => {
                        console.log("addDbCourseManagementDetails success");
                        // モーダルを閉じる
                        const modal = document.getElementById("modal-course-management");
                        if (modal) {
                            modal.classList.toggle('is-active');
                        }        
                        if (this.closeCallback) {
                            this.closeCallback();
                        }                        
                    })
                    .catch((e) => {
                        console.log("addDbCourseManagementDetails error");
                    });
            })
            .catch((e) => {
                console.log(e);
                //TODO エラー 表示
            });
    }
}
